import {getFieldValueErrorKey} from '@utils/fieldValueValidation';

interface ValidatedField {
    value?: unknown;
    validation?: {type?: string | null} | null;
}

export function getFieldValidationErrorKey(field: ValidatedField | null | undefined): string | null {
    const validationType = field?.validation?.type;
    const value = field?.value;

    if (typeof value !== 'string') {
        return null;
    }

    return getFieldValueErrorKey(validationType, value);
}

export function getHasFieldValidationError(field: ValidatedField | null | undefined): boolean {
    return getFieldValidationErrorKey(field) !== null;
}
